import AbstractPage from 'pages/AbstractPage';

export default class ProductListPage extends AbstractPage {
    constructor() {
        super();
        this.bind();
    }

    bind() {
        $('.product-list-item__buy-button').on('click', this.onBuyButtonClick.bind(this));
        $('.catalog-block-list').on('click', '.catalog-block-list__more', this.nextPage.bind(this));
    }

    onBuyButtonClick(e) {
        e.stopPropagation();
    }

    nextPage(e) {
        e.preventDefault();

        $.ajax({
            url: $(e.currentTarget).attr('data-url'),
            method: 'get',
            dataType: 'html',
        }).done((response) => {
            // Ugly way
            $('.catalog-block-list').append($(response).find('.catalog-block-list .product-list-item'));

            const $newNextPage = $(response).find('.catalog-block-list__more');
            const $nextPage = $('.catalog-block-list__more');

            if ($newNextPage.length === 0) {
                $nextPage.remove();
            } else {
                // Move to the end
                $nextPage.appendTo($('.catalog-block-list'));
                $nextPage.attr('data-url', $newNextPage.attr('data-url'));
            }

            $(document).trigger('custom:ProductListItemCollection.reinit');
        });
    }
}

$(function () { app.pageController = new ProductListPage(); });
